import { useMemo } from 'react'
import { ParsedQuery } from 'query-string'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'

export const useNewModel = (parsedQuery?: ParsedQuery<string>): boolean => {
  const location = useLocation()
  const queryParams: ParsedQuery<string> = useMemo(() => {
    if (parsedQuery) {
      return parsedQuery
    }
    return queryString.parse(location.search, { arrayFormat: 'bracket' })
  }, [location.search, parsedQuery])
  return queryParams.model == null || queryParams.model !== 'old'
}
